<template>
    <section class="section section-savings bg-primary-color-light">
        <div class="container has-background-white">
            <div class="content">
                <div class="columns">
                    <div class="column is-1">
                        <figure class="media-left">
                            <p class="image is-64x64">
                                <img src="./../assets/img/icons/icon_savings.png">
                            </p>
                        </figure>
                    </div>
                    <div class="column">
                        <h3>Einsparungen</h3>
                        <p><strong>Elektrische Autos</strong></p>
                        <ul>
                            <li>E-Autos sind <strong>10 Jahre von der KFZ-Steuer befreit</strong></li>
                            <li>Bund und Hersteller fördern derzeit mit bis zu <strong>4.000 Euro</strong> Zuschuss reine E-Autos</li>
                            <li><strong>3.000 Euro Zuschuss</strong> gibt es für Plug-In-Hybrid-Fahrzeuge beim Kauf oder Leasing</li>
                            <li><strong>Wall-Box-Förderung</strong> durch die KfW-Bank möglich</li>
                            <li><strong>Wartungskosten</strong> für E-Autos betragen durchschnittlich <strong>65%</strong> von konventionellen Autos</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Savings"
    }
</script>

<style scoped>

</style>